import { useState, useCallback } from 'react';
import { apiService } from '../services/apiService';
import { ExportableColumn } from '../components/ExportModal';
import { SettingItem } from '../types';
import { GetReceiptsOptions } from '../types';

interface ImportExportProps {
    filters: Omit<GetReceiptsOptions, 'page' | 'limit' | 'sortConfig'>;
    onActionComplete: () => void;
}

export const useImportExport = ({ filters, onActionComplete }: ImportExportProps) => {
    const [isProcessing, setIsProcessing] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleFileImport = useCallback(async (file: File, initialTags: SettingItem[] = []) => {
        setIsProcessing(true);
        setError(null);

        const formData = new FormData();
        formData.append('csvfile', file);
        formData.append('tags', JSON.stringify(initialTags));

        try {
            const result = await apiService.importCsv(formData);
            alert(result.message);
        } catch (e: any) {
            setError(`Nepodařilo se importovat CSV: ${e.message}`);
            alert(`Chyba při importu: ${e.message}`);
        } finally {
            setIsProcessing(false);
            onActionComplete();
        }
    }, [onActionComplete]);

    const handleExport = useCallback(async (columns: ExportableColumn[]) => {
        setIsProcessing(true);
        setError(null);
        try {
            const columnKeys = columns.map(c => c.key);
            await apiService.triggerCsvExport(filters, columnKeys);
        } catch (e: any) {
            console.error("Chyba při exportu:", e);
            setError("Nepodařilo se exportovat data.");
            alert("Chyba při exportu. Zkontrolujte konzoli pro více detailů.");
        } finally {
            setIsProcessing(false);
        }
    }, [filters]);

    return {
        isProcessing,
        error,
        handleFileImport,
        handleExport,
    };
};